import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import type { RootState } from '../store';
import { canUseAdminAccess, resolveAdminViewer, type AdminAccess } from '../utilities/adminAccess';

/**
 * Who the admin console is acting as: Full access (eleplan-admin on the
 * current account) or the tiers on the viewer's own account. `canUse` hides
 * what the server would refuse; the server still decides every call.
 */
export const useAdminAccess = () => {
  const account = useSelector((state: RootState) => (state as any).session?.account);
  const accountList = useSelector((state: RootState) => (state as any).accounts?.list);
  const cognitoId = useSelector((state: RootState) => (state as any).authentication?.user?.cognito_id);
  return useMemo(() => {
    const viewer = resolveAdminViewer({
      session: { account },
      accounts: { list: accountList },
      authentication: { user: { cognito_id: cognitoId } },
    });
    return {
      ...viewer,
      canUse: (access?: AdminAccess) => canUseAdminAccess(viewer.permissions, access),
    };
  }, [account, accountList, cognitoId]);
};
